import React, {useState} from 'react';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {Heart} from "lucide-react";
import {useTranslation} from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import AuthCheckerIconButton from "../../components/AuthCheckerIconButton";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import {updateRedux} from "../../../../../config/Security";
import {connect} from "trim-redux";
import {indexof} from "stylis";
import {CircularProgress, Hidden} from "@mui/material";
import clsx from "clsx";
import LoginDialog from "../../components/LoginDialog";

function WishListButton({id,classes,user,isAuth,is_icon}) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const handleRequest = async () => {
        setLoading(true);
        const data = new FormData();
        data.append('shop_id', id);
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        try {
            await axios.post(`${defaultVariables.url}/wishlist/toggle`, data, config);
            await updateRedux();
            setLoading(false);
        } catch (error) {
            console.error(error.response);
            setLoading(false);
        }
    };
    const isInWishlist = () => {
        if(!!isAuth){
            let list = user?.wishlists;
            if(!!list){
                if(list.indexOf(id) > -1){
                    return true
                }
            }

        }
        return false
    }

    return (

        <div>
            <Tooltip title={t('add-wishlist')}>
                <AuthCheckerIconButton
                className={clsx(!is_icon ? "wishlist-icon" : "wishlist-icon is-icon",isInWishlist() ? "active" : "")}
                icon={!!loading ? <CircularProgress thickness={2} color="primary" size={22}/> : <Heart className="lucide-icon lucide-large"/>}
                run={() => handleRequest()}
                loading={loading}
                />
                {
                    !is_icon &&
                    <span style={{cursor:"pointer"}} onClick={() => !!isAuth ? handleRequest() : setOpen(true)}>
                        <Hidden mdDown>
                            {
                                !!isInWishlist() ?
                                    <span className="whishlist-text">{t('added-wishlist')}</span>
                                    :
                                    <span className="whishlist-text">{t('add-wishlist')}</span>
                            }
                        </Hidden>
                    </span>
                }


            </Tooltip>
            <LoginDialog open={open} setOpen={setOpen}/>
        </div>
    );
}
const mapStateToProps = (state) => ({
    user: state.user,
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(WishListButton));
